import { inject, Injectable } from '@angular/core';
import { ConfigOption, FormlyFieldConfig } from '@ngx-formly/core';
import { FormlyFieldConfigPresetProvider } from '@ngx-formly/core/lib/models';
import { CountryFacade } from '@portal/application/data-access';
import { map } from 'rxjs';
import { mapCountriesToFormlySelectOption } from '../util';

@Injectable()
export class CountryPresetProvider implements FormlyFieldConfigPresetProvider {
  private readonly countryFacade = inject(CountryFacade);

  getConfiguration(): FormlyFieldConfig {
    return {
      type: 'mat-select',
      props: {
        label: 'Country',
        placeholder: 'Please Select',
        options: this.countryFacade.allCountry$?.pipe(map(o => mapCountriesToFormlySelectOption(o))),
      },
    };
  }
}

export function registerCountryPreset(): ConfigOption {
  return { presets: [{ name: 'country', config: new CountryPresetProvider() }] };
}
